<script>
import RawData from "@/components/widgets/raw-data.vue";
import InventoryCardList from "./inventory-card-list.vue";
export default {
    name: "InventoryOtherItems",
    props: {
        itemData: {
            type: Object,
            required: true,
        },
        type: {
            type: String,
            default: "notfound",
        },
        viewFrom: {
            type: String,
            default: "supply",
        },
    },
    components: {
        RawData,
        InventoryCardList,
    },
    computed: {
        dataList() {
            if (this.type == 'notfound') {
                return this.itemData.notFoundItems;
            } else if (this.type == 'unserviceable') {
                return this.itemData.unserviceableItems;
            } else if (this.type == 'notbooked') {
                return this.itemData.notBooked;
            }
            return [];
        },
        propertyFiltered() {
            if (this.itemData) {
                let data = this.dataList;
                if (this.filterEmployeeId) {
                    data = data.filter((item) => {
                        return item.employeeIdNumber == this.filterEmployeeId;
                    });
                }
                if (this.itemData.filter.trim() != "" && this.itemData.filter) {
                    data = data.filter((item) => {
                        return item.filterKey.toUpperCase().includes(this.itemData.filter.toUpperCase());
                    });
                }
                return data;
            }
            return [];
        },
        propertyRows() {
            if (this.itemData) {
                if ((this.itemData.filter.trim() != "" && this.itemData.filter) || this.filterEmployeeId) {
                    return this.propertyFiltered.length;
                } else {
                    return this.dataList.length;
                }
            }
            return 0;
        },
    },
    data() {
        return {
            checkedToggleList: [],
            propertyFields: [
                {
                    key: "Name",
                    sortable: true,
                    label: "Property",
                },
            ],
            sortBy: "id",
            sortDesc: true,
            currentPage: 1,
            perPage: 10,
        };
    },
    methods: {
        resetToggle(row) {
            row.toggleAll = false;
            row.notFoundItems.map((item) => {
                item.items.map((prop) => {
                    prop.toggleSelected = false;
                });
            });
        },
        checkToggle({ property, parent, checkEvent }) {
            if (checkEvent.srcElement.checked) {
                if (!this.checkedToggleList.find(prop => prop.id == property.id)) {
                    this.checkedToggleList.push({ id: property.id, propertyId: property.propertyId });
                }
                var count = 0;
                parent.items.forEach((item) => {
                    if (item.toggleSelected === true) {
                        count++;
                    }
                });
                if (count == parent.items.length) {
                    parent.toggleAll = true;
                } else {
                    parent.toggleAll = false;
                }
            } else {
                this.checkedToggleList = this.checkedToggleList.filter((item) => item.id !== property.id);
                parent.toggleAll = false;
            }
        },
        changeBookedStatus({ id, booked }) {
            var inventoryItemIds = [];
            inventoryItemIds.push(id);
            this.$store
                .dispatch("propertyinventory/UpdateBookedStatus", { inventoryItemIds, booked })
                .then((res) => {
                    if (res.data.error) {
                        this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                        return;
                    }
                    this.showToast("Status updated successfully", "success");
                })
                .catch((error) => {
                    this.showToast("Something went wrong.", "error");
                });
        },

        changeMultipleBookedStatus(booked) {
            var inventoryItemIds = this.checkedToggleList.map(prop => prop.id);
            this.$swal({
                title: "Are you sure?",
                text: `${inventoryItemIds.length} ${inventoryItemIds.length > 1 ? "properties" : "property"} selected. `,
                icon: "question",
                showCancelButton: true,
                confirmButtonColor: "#34c38f",
                cancelButtonColor: "#5c636a",
                confirmButtonText: "Yes, change it!",
                allowOutsideClick: false,
            }).then((result) => {
                if (result.isConfirmed) {
                    this.$store
                        .dispatch("propertyinventory/UpdateBookedStatus", { inventoryItemIds, booked })
                        .then((res) => {
                            if (res.data.error) {
                                this.showToast("Cannot update info. " + res.data.errorMessage, "error");
                                return;
                            }
                            this.dataList.forEach((item, index) => {
                                item.items.map(prop => {
                                    if (inventoryItemIds.includes(prop.id)) {
                                        let foundIndex = item.items.findIndex(x => x.id == prop.id);
                                        if (foundIndex != -1) {
                                            item.items.splice(foundIndex, 1);
                                        }
                                    }
                                })
                                if (item.items.length == 0) {
                                    this.dataList.splice(index, 1);
                                }
                            });
                            this.checkedToggleList = []
                            this.showToast("Status updated successfully", "success");
                        })
                        .catch((error) => {
                            this.showToast("Something went wrong.", "error");
                        });
                }
            });
        }
    }
};
</script>
<template>
    <div class="mt-2">
        <!-- <div class="d-flex justify-content-between mb-2">
            <div class="d-flex">

            </div>
            <div class="d-flex mt-1">
                <div class="d-flex align-items-center float-end">
                    <button
                        type="button"
                        @click="$emit('selectFundCluster', 'rpcsp')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                    >
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCSP
                    </button>
                    <button
                        type="button"
                        @click="$emit('selectFundCluster', 'rpcppe')"
                        class="btn btn-sm btn-purple d-flex align-items-center ms-1"
                    >
                        <i class="bx bx-printer fs-6 me-1"></i>Print RPCPPE
                    </button>
                </div>
            </div>
        </div> -->
        <div class="d-flex mb-2">
            <transition name="fade">
                <transition name="slide">
                    <div v-if="type == 'notbooked' && checkedToggleList.length > 0"
                        class="d-flex align-items-center mt-2">
                        <button type="button" class="btn btn-sm btn-success d-flex align-items-center"
                            @click="changeMultipleBookedStatus(true)">
                            <i class="bx bx-printer fs-6 me-1"></i>Update to Booked ({{ checkedToggleList.length }})
                        </button>
                    </div>
                </transition>
            </transition>
        </div>
        <b-table class="propertyTable datatables target-table" :items="propertyFiltered" :fields="propertyFields"
            responsive="sm" :per-page="itemData.perPage" :current-page="itemData.currentPage" :sort-by="sortBy"
            :sort-desc="false" :busy="itemData.tableBusy" bordered show-empty>
            <template #empty>
                <b-card-header>
                    <div class="text-center">
                        <div v-if="itemData.filter != ''">
                            <i class="fas fa-exclamation-triangle me-2"></i>There
                            are no properties matching your request
                        </div>
                        <div v-else>
                            <i class="fas fa-exclamation-triangle me-2"></i>No
                            properties available
                        </div>
                    </div>
                </b-card-header>
            </template>
            <template #table-busy>
                <b-card-header>
                    <div class="d-flex justify-content-center align-items-center p-2">
                        <div class="preloader-component me-2">
                            <div class="status">
                                <div class="spinner-chase w-20px h-20px">
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                    <div class="chase-dot"></div>
                                </div>
                            </div>
                        </div>
                        <strong>Loading...</strong>
                    </div>
                </b-card-header>
            </template>
            <template #head(name)="data">
                <div class="d-flex align-items-center gap-2">
                    <span>Property</span>
                    <button class="btn btn-sm btn-purple" @click.stop="$emit('generateReport')"
                        v-if="type != 'notbooked'"><i class="bx bx-printer"></i>Generate {{ type === 'notfound' ?
                            'Missing' : 'Unserviceable' }}
                        Report</button>
                </div>
            </template>
            <template #cell(name)="accountableRow">
                <div class="position-relative ms-1">
                    <RawData :data="accountableRow.item" v-if="$store.state.decrypt.isAdmin()"
                        :keyId="accountableRow.item.employeeIdNumber" :exclude="['properties']" />
                </div>
                <div class="py-2">
                    <div class="d-flex justify-content-between cursor-pointer px-3 pb-1"
                        @click="accountableRow.item.showProperty = !accountableRow.item.showProperty"
                        :class="{ 'mb-2 border-bottom': accountableRow.item.showProperty }">
                        <div>
                            <span class="text-warning font-size-17">{{ accountableRow.item.accountableOfficer }}</span>
                            <div class="d-flex gap-1" v-if="type === 'notfound'">
                                <button class="btn btn-purple btn-sm"
                                    @click.stop="$emit('printDemandLetter', accountableRow.item)"><i
                                        class="bx bx-printer"></i> Print Demand Letter</button>
                                <button class="btn btn-purple btn-sm"
                                    @click.stop="$emit('printICF', accountableRow.item)"><i class="bx bx-printer"></i>
                                    Print ICF</button>
                            </div>
                        </div>
                        <span v-if="!accountableRow.item.showProperty">Show {{ accountableRow.item.totalItems }}
                            properties</span>
                    </div>
                    <b-collapse :visible="accountableRow.item.showProperty" role="tabpanel">
                        <div v-if="accountableRow.item.showProperty">
                            <InventoryCardList :type="type" :filter="itemData.filter" :accountableRow="accountableRow"
                                :viewFrom="viewFrom"
                                @checkToggle="checkToggle" @changeBookedStatus="changeBookedStatus" />
                            <!-- @changePropertyStatus="changePropertyStatus"
                            @printParProperty="$emit('printParProperty', $event)"
                            @printIcsProperty="$emit('printIcsProperty', $event)"
                            @printStickerProperty="$emit('printStickerProperty', $event)"
                            @printPropertyCard="$emit('printPropertyCard', $event)"
                            @updateItem="$emit('updateItem', $event)"
                            @deleteItem="$emit('deleteItem', $event)"
                            @getEmployee="$emit('getEmployee', $event)"
                            @getLocation="$emit('getLocation', $event)"
                            @checkToggle="checkToggle" -->
                        </div>
                    </b-collapse>
                </div>
            </template>
        </b-table>
        <div class="row">
            <div v-if="propertyRows > 0" class="col">
                Showing
                {{ (itemData.currentPage - 1) * itemData.perPage + 1 }} -
                {{
                    propertyRows > (itemData.currentPage - 1) *
                        itemData.perPage + itemData.perPage ?
                        (itemData.currentPage - 1) * itemData.perPage +
                        itemData.perPage
                        : propertyRows
                }}
                of {{ propertyRows }}
            </div>
            <div class="col">
                <div @click="resetToggle(itemData)" class="dataTables_paginate paging_simple_numbers float-end">
                    <ul class="pagination pagination-rounded mb-0" style="z-index: -1">
                        <b-pagination v-model="itemData.currentPage" :total-rows="propertyRows"
                            :per-page="itemData.perPage"></b-pagination>
                    </ul>
                </div>
            </div>
        </div>
    </div>
</template>